import { createSlice } from "@reduxjs/toolkit";
import { push } from "connected-react-router";

import { changePassword as changePasswordAPI } from "../../sdk/apis";

export const pwInfoSlice = createSlice({
  name: 'pwInfo',
  initialState: {
    success: false,
    message:'',
  },
  reducers: {
    setSuccess: (state) => {
      state.success = true;
      state.message = 'パスワードが変更されました。';
    },
    setFailed: (state, action) => {
      state.success = false;
      state.message = action.payload; 
    }
  },
});

export const { setSuccess, setFailed } = pwInfoSlice.actions;

export function changePassword(oldPassword: string, newPassword: string, newPasswordConfirm: string) {
  return (dispatch: (f: any) => void, getState: () => any) => {
    const s = getState();
    changePasswordAPI(oldPassword, newPassword, newPasswordConfirm).then((result) => {
      if (result.succeeded) {
        dispatch(setSuccess());
        dispatch(push('/change_password/'));
      }
      else {
        dispatch(setFailed(result.message));
      }
    })
  }
}


export default pwInfoSlice.reducer;
